import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import React, {
  Component,
} from 'react';
import classes from './MultiSearchFilterDropdown.module.scss';

export interface IProps {
  label?: string;
  searchFilterDropdown?: {
    value: string [];
    initialValue?: string [];
    filters: Array<any>;
    onChange(status: string []): void;
  };
  error?: boolean;
  required?: boolean;
}

interface State {
  status: string [];
}

class MultiSearchFilterDropdown extends Component<IProps, State> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      status: this.props.searchFilterDropdown!.value,
    };
  }

  clear() {
    this.setState({
      status: this.props.searchFilterDropdown?.initialValue as any | null,
    });
  }

  getMenuItem(filter: any) {
    return (
      <MenuItem value={filter.value}>
        {filter.name}
        {console.log(`${filter.value}  ${filter.name}`)}
      </MenuItem>
    );
  }

  selectChange = (event: any): void => {
    this.setState({
      status: event.target.value,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <form className={classes.form} autoComplete="off">
          <FormControl
            variant="outlined"
            className={classes.select}
            style={{marginBottom: "20px"}}
            error={this.props.error}
            required={this.props.required}
          >
            <InputLabel htmlFor="status">{this.props.label}</InputLabel>
            <Select
              multiple
              value={this.state.status}
              onChange={this.selectChange}
              label={this.props.label}
              error={this.props.error}
            >
              {this.props.searchFilterDropdown!.filters.map((filter) => (
                <MenuItem key={filter.value} value={filter.value}>
                  {filter.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </form>
      </div>
    );
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.status !== prevState.status) {
      this.props.searchFilterDropdown!.onChange(this.state.status);
    }
  }
}

export default MultiSearchFilterDropdown;
